import PropTypes from 'prop-types';

import { Avatar, Box, Group, Stack, Title } from '@mantine/core';
import Text from '@ui/components/Text/Text';
import IconButton from '@ui/components/IconButton/IconButton';
import DefaultImg from '../../assets/img/pending-invite.png';

const WorkspaceInvitationBox = ( { invitation, showDeleteIcon, onDeleteClicked } ) => (
	<Group className="WorkspaceMemberWithRole" spacing={2} w="100%" position="apart" noWrap>
		<Group spacing={16} style={{ flex: 1 }} position="left" noWrap>
			<Box w="40px" h="40px">
				<Avatar src={DefaultImg} />
			</Box>
			<Stack spacing={0}>
				<Title order={6}>
					Pending Invite
				</Title>
				<Text lineClamp={1} color="gray.6">{invitation.email}</Text>
			</Stack>
		</Group>
		<Text w="120px" variant="footnote">0 Owned</Text>
		<Text w="120px" variant="footnote">
			{invitation.role?.name}
		</Text>
		<Box w="40px" align="center">
			{showDeleteIcon && (
				<IconButton
					className="remove"
					icon="delete_outlined"
					size={20}
					color="red.6"
					onClick={onDeleteClicked}
				/>
			)}
		</Box>
	</Group>
);

WorkspaceInvitationBox.propTypes = {
	invitation: PropTypes.shape( {
		email: PropTypes.string,
		role: PropTypes.string
	} ),
	showDeleteIcon: PropTypes.bool,
	onDeleteClicked: PropTypes.func
};

WorkspaceInvitationBox.defaultProps = {
	invitation: null,
	showDeleteIcon: false,
	onDeleteClicked: () => {}
};

export default WorkspaceInvitationBox;
